import {format} from 'date-fns';
import cookies from 'js-cookie';
import {toLower} from 'lodash';

import store from '@/store/store';

export default {
  pmode() {
        return process.env.VUE_APP_PMODE;
  },
  admin() {
        return store.state.webkey.admin || cookies.get('TAC_PBT_ADMIN') == 1;
  },
  tacId() {
        return cookies.get('TAC_PBT_ID');
  },
  webkeyId() {
        return cookies.get('TAC_PBT_WEBKEY') ? cookies.get('TAC_PBT_WEBKEY') : store.state.webkey.id;
  },
  fmtDate(d, f = 'yyyy-MM-dd') {
        let out = '';
        try {
            // for some reason using '-' in dates causes an off by one error, format to y/m/d instead
            d = d.replace(/-/g, '/');
            out = format(new Date(d), f);
        } catch (e) { /* noop */
        }
        
        return out;
  },
  fmtUrlParam(s) {
        return toLower(s.replace(/[^a-z0-9]/gi, '_').replace(/_+|\1/gi, '_'));
  },
  async sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
  },
  callUrl(type, id) {
        let url = toLower(type) == 'pr' ? process.env.VUE_APP_WEBPR_URL : process.env.VUE_APP_WEBER_URL;
        return url + `?objtype=shortcut&startoption=reuse_last_session&startlink=view&startdata=${id}`;
  },
}
